/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthDocumentSource } from './PalReauthDocumentSource';
import {
    PalReauthDocumentSourceFromJSON,
    PalReauthDocumentSourceFromJSONTyped,
    PalReauthDocumentSourceToJSON,
    PalReauthDocumentSourceToJSONTyped,
} from './PalReauthDocumentSource';

/**
 * 
 * @export
 * @interface PalReauthSubmissionDocument
 */
export interface PalReauthSubmissionDocument {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    source: PalReauthDocumentSource;
    /**
     * 
     */
    key_date?: string | null;
    /**
     * 
     */
    discipline?: string | null;
    /**
     * 
     */
    page_count?: number | null;
    /**
     * 
     */
    filesize_in_bytes?: number | null;
    /**
     * Signed URL, injected at read time and valid for one hour
     */
    access_url?: string | null;
    /**
     * Whether the document goes into the submission package.
     */
    is_selected: boolean;
    /**
     * Net Health lists the document but cannot produce the file, so it cannot be viewed, downloaded or included in the package.
     */
    is_render_unavailable: boolean;
}



/**
 * Check if a given object implements the PalReauthSubmissionDocument interface.
 */
export function instanceOfPalReauthSubmissionDocument(value: object): value is PalReauthSubmissionDocument {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('is_selected' in value) || value['is_selected'] === undefined) return false;
    if (!('is_render_unavailable' in value) || value['is_render_unavailable'] === undefined) return false;
    return true;
}

export function PalReauthSubmissionDocumentFromJSON(json: any): PalReauthSubmissionDocument {
    return PalReauthSubmissionDocumentFromJSONTyped(json, false);
}

export function PalReauthSubmissionDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'source': PalReauthDocumentSourceFromJSON(json['source']),
        'key_date': json['key_date'] === undefined ? undefined : json['key_date'] === null ? null : json['key_date'],
        'discipline': json['discipline'] === undefined ? undefined : json['discipline'] === null ? null : json['discipline'],
        'page_count': json['page_count'] === undefined ? undefined : json['page_count'] === null ? null : json['page_count'],
        'filesize_in_bytes': json['filesize_in_bytes'] === undefined ? undefined : json['filesize_in_bytes'] === null ? null : json['filesize_in_bytes'],
        'access_url': json['access_url'] === undefined ? undefined : json['access_url'] === null ? null : json['access_url'],
        'is_selected': json['is_selected'],
        'is_render_unavailable': json['is_render_unavailable'],
    };
}

export function PalReauthSubmissionDocumentToJSON(json: any): PalReauthSubmissionDocument {
    return PalReauthSubmissionDocumentToJSONTyped(json, false);
}

export function PalReauthSubmissionDocumentToJSONTyped(value?: PalReauthSubmissionDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'source': PalReauthDocumentSourceToJSON(value['source']),
        'key_date': value['key_date'],
        'discipline': value['discipline'],
        'page_count': value['page_count'],
        'filesize_in_bytes': value['filesize_in_bytes'],
        'access_url': value['access_url'],
        'is_selected': value['is_selected'],
        'is_render_unavailable': value['is_render_unavailable'],
    };
}

